import DefaultLayout from 'components/layout/DefaultLayout';
import ActivePlusSessionsPage from 'components/session/ActivePlusSessionsPage';
import ClientPersonalSessionsPage from 'components/session/ClientPersonalSessionsPage';
import GroupSessionsPage from 'components/session/GroupSessionsPage';
import TrainerGroupSessionsPage from 'components/session/TrainerGroupSessionsPage';
import SessionCalendar from 'components/session/calendar/SessionCalendar';
import SessionEdit from 'components/session/SessionEdit';
import SessionList from 'components/session/SessionList';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const sessionRoutes = [
  // Shared routes

  {
    key: 'calendar',
    exact: true,
    path: routes.calendar.path,
    component: SessionCalendar,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.supervisor, roles.trainer, roles.client],
    requiresMembership: true
  },
  {
    key: 'session-edit',
    exact: true,
    path: routes.editSession.path,
    component: SessionEdit,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'group-sessions',
    exact: true,
    path: routes.groupSessions.path,
    component: GroupSessionsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'trainer-group-sessions',
    exact: true,
    path: routes.trainerGroupSessions.path,
    component: TrainerGroupSessionsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.trainer]
  },
  {
    key: 'session-list',
    exact: true,
    path: routes.listSession.path,
    component: SessionList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.supervisor, roles.trainer]
  },

  // Client only routes

  {
    key: 'session-history',
    exact: true,
    path: routes.clientSessions.path,
    component: ClientPersonalSessionsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true
  },
  {
    key: 'active-plus-sessions',
    exact: true,
    path: routes.activePlusSessions.path,
    component: ActivePlusSessionsPage,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true
  }
];

export default sessionRoutes;
